module.exports = __webpack_public_path__ + "static/img/641.4e84f785.webp";